<template>
  <v-list>
    <template v-for="locacao in data">
      <v-list-item :key="locacao.id">
        <v-list-item-content>
          <v-list-item-title>
            <router-link
              :to="{
                name: 'locacoes_locacao_page',
                params: { codigo: locacao.codigo }
              }"
            >
              {{ locacao.codigo }}
            </router-link>
          </v-list-item-title>
          <v-list-item-subtitle>
            {{ locacao.total_formatado }}
          </v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-action>
          <!-- <v-btn
            v-if="locacao.pago"
            @click="handleClickReverter"
            small
            color="primary"
            outlined
          >
            Reverter
          </v-btn> -->
          <ServerButton
            v-if="locacao.pago"
            :action="() => locacoes.locacoes.marcarComoNaoPago(locacao.codigo)"
            @executed="handleClickReverter"
            outlined
            small
          >
            Reverter
          </ServerButton>
          <v-btn
            v-else
            @click="handleClickPagar(locacao)"
            color="primary"
            small
          >
            Pagar
          </v-btn>
        </v-list-item-action>
      </v-list-item>
      <v-divider :key="locacao.id + '_divisor'"></v-divider>
    </template>
    <v-skeleton-loader
      v-if="loading"
      type="list-item-two-line,list-item-two-line,list-item-two-line,list-item-two-line"
    ></v-skeleton-loader>
    <v-list-item v-else-if="emptyData" class="text-center">
      <v-list-item-content>
        <v-list-item-title>
          Nenhuma locação encontrada
          <v-btn @click="refresh()" color="primary" icon>
            <v-icon>mdi-refresh</v-icon>
          </v-btn>
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>
    <MarcarComoPagoDialog
      ref="marcar_como_pago"
      :locacao_codigo="locacao_codigo"
      @pago="handlePagamentoEfetuado"
    />
  </v-list>
</template>

<script>
import QueryMixin from "../mixins/QueryMixin";
import locacoes from "../services/locacoes";
import MarcarComoPagoDialog from "@/components/locacoes/locacoes/MarcarComoPagoDialog.vue";
import ServerButton from "./server/ServerButton.vue";

export default {
  mixins: [QueryMixin],

  components: {
    MarcarComoPagoDialog,
    ServerButton
  },

  props: {
    clienteId: Number
  },

  data() {
    return {
      locacoes,
      locacao_codigo: null
    };
  },

  methods: {
    async handleClickReverter(locacao) {
      this.data = this.data.map(item => {
        if (locacao.id === item.id) {
          return {
            ...item,
            pago: false
          };
        }

        return item;
      });
    },

    handlePagamentoEfetuado(locacao) {
      this.data = this.data.map(item => {
        if (locacao.id === item.id) {
          return {
            ...item,
            pago: true
          };
        }

        return item;
      });
    },

    handleClickPagar(locacao) {
      this.locacao_codigo = locacao.codigo;
      this.$refs.marcar_como_pago.open({ total_pago: locacao.total });
    },

    async getData() {
      const response = await locacoes.locacoes.indexarPorCliente(
        this.clienteId
      );

      return response.data;
    }
  },

  computed: {}
};
</script>
